<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a widget for adding multiple objects from a list to another item (e.g. adding schools to a student)
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    * @author Rumyana Gilson <rgilson@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div :style="hide_if">
        <input type="hidden" :name="name" :value="ids">
        <div class="" :id="modal_name" >                   
            <div class="row">
                <div class="col-sm-12 mt-2">
                    <label>Assign {{object_name}}</label><i class='text-muted'> - make sure to click +Add button to add your selection</i>
                    <div class="input-group">
                        <select v-model="object_value" class="form-control">
                            <option value="0">Please Select {{object_name}}</option>
                            <option v-if="add_new" value="-1">Add New {{object_name}}</option>
                            <option v-for="object in all_objects_actual" :key="object.id" :value="object.id">{{object.name + (check_extra(object.id) && object.extra !== undefined ? ' (' + object.extra + ')' : '')}}
                            </option>
                        </select>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-success btn-sm" @click="add_item_to_list">
                            <i class="fa fa-plus pr-1" aria-hidden="true"></i>Add</button>
                        </div>                         
                    </div>
                </div>
            </div><!--  END row -->
            <div class="row pt-3">
                <div class="table-responsive col-sm-12">
                    <table class="table table-striped table-sm">
                        <tbody>
                            <tr v-if="default_all && objects_actual.length == 0">
                                <td>
                                    All Assigned
                                </td>
                            </tr> 
                            <tr v-for="(object, index) in objects_actual" :key="object.id + '_' + index + (has_secondary_array ? '_' + object[secondary_variable] : '')">
                                <td v-if="object.id == -1">
                                    New: <input type="text" class="form-control" v-model="object.name" />
                                </td>
                                <td v-else-if="check_route(object.id)">
                                    {{object.name}}
                                </td>
                                <td v-else>
                                    {{object.name}}
                                </td>
                                <td v-if="check_extra(object.id)">
                                    {{object.extra}}
                                </td>
                                <td v-if="has_secondary_array">
                                    <select v-model="object[secondary_variable]">
                                        <option v-if="secondary_no_selection.length > 0" value="0">{{secondary_no_selection}}</option>
                                        <option v-for="sec in secondary_array" :key="sec.id" :value="sec.id">{{sec.name}}</option>
                                    </select>
                                </td>
                                <td v-if="has_tertiary_array">
                                    <select v-model="object[tertiary_variable]">
                                        <option v-if="tertiary_no_selection.length > 0" value="0">{{tertiary_no_selection}}</option>
                                        <option v-for="sec in tertiary_array" :key="sec.id" :value="sec.id">{{sec.name}}</option>
                                    </select>
                                </td>
                                <td class="float-right">
                                    <button type="button" v-if="object.can_update" class="btn btn-danger btn-sm" @click="remove_from_list(object.id, (has_secondary_array ? object[secondary_variable] : null))">
                                        <i class="fa fa-times pr-1" aria-hidden="true"></i>Remove</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> <!-- END row  table-->
        </div><!--  END div id="modal_name" -->

    </div>
</template>

<script>
    export default{
        props: {
            //the title of the object
            name: {
                type: String,
                default: ''
            },
            //a list of all selected objects in JSON format
            objects: {
                type: Array
            },
            //a list of all objects in JSON format
            all_objects: {
                type: Array
            },
            //a list of secondary values to link to the array
            secondary_array: {
                type: Array
            },
            //the variable for the secondary value
            secondary_variable: {
                type: String,
                default: ''
            },
            //if set, will display this as a no selection
            secondary_no_selection: {
                type: String,
                default: ''
            },
            //a list of tertiary values to link to the array
            tertiary_array: {
                type: Array
            },
            //the variable for the tertiary value
            tertiary_variable: {
                type: String,
                default: ''
            },
            //if set, will display this as a no selection
            tertiary_no_selection: {
                type: String,
                default: ''
            },
            //the name of the object type e.g. Company
            object_name: {
                type: String,
                default: ''
            },
            //they don't seem to work well with v-if, so if need to use in an if, use list_if instead
            list_if: {
                type: Boolean,
                default: true
            },
            //if true, it will be set to show a default value of all
            default_all: {
                type: Boolean,
                default: false
            },
            //if true, indicates it is a school selection, so sets school parameters
            is_school: {
                type: Boolean,
                default: false
            },
            //if true, indicates that you can add a new record
            add_new: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.objects_actual = this.objects;
            if(this.is_school){
                this.$listSchoolIds = this.objects_actual;
            }
        },
        data() {
            return {
                //the currently selected item
                object_value: '0',
                //an array of selected items
                objects_actual: [],
            }
        },
        computed: {
            //an array of all possible items
            all_objects_actual: function(){
                if(this.school_ids.length > 0 && this.all_objects.length > 0 && this.all_objects[0].school_id !== undefined){
                    var arr = [];
                    for(var i=0; i<this.all_objects.length; i++){
                        var found = false;
                        for(var j=0; j<this.school_ids.length; j++){
                            var object_school_ids = (this.all_objects[i].school_id + '').split(',');
                            for(var k=0; k<object_school_ids.length; k++){
                                if(object_school_ids[k] == this.school_ids[j].id){
                                    arr.push(this.all_objects[i]);
                                    j = this.school_ids.length;
                                    k = object_school_ids.length;
                                    found = true;
                                }
                            }
                        }
                        if(!found){
                            for(var j=0; j<this.objects_actual.length; j++){
                                if(this.all_objects[i].id == this.objects_actual[j].id){
                                    arr.push(this.all_objects[i]);
                                    j = this.objects_actual.length;
                                    found = true;
                                }
                            }
                        }
                    }
                    return arr;
                } else {
                    return this.all_objects;
                }
            },
            has_secondary_array: function(){
                return this.secondary_array !== undefined && this.secondary_array !== null && this.secondary_array.length > 0 && this.secondary_variable.length > 0
            },
            has_tertiary_array: function(){
                return this.tertiary_array !== undefined && this.tertiary_array !== null && this.tertiary_array.length > 0 && this.tertiary_variable.length > 0
            },
            /**
             * returns a list of all ids of the selected items
             * 
             * @return String the modal name
             */
            ids: function(){
                if(this.has_secondary_array){
                    var arr = [];
                    for(var i=0; i<this.objects_actual.length; i++){
                        arr[i] = {};
                        arr[i]['id'] = this.objects_actual[i].id;
                        arr[i][this.secondary_variable] = this.objects_actual[i][this.secondary_variable];
                        if(this.has_tertiary_array){
                            arr[i][this.tertiary_variable] = this.objects_actual[i][this.tertiary_variable];
                        }
                    }
                    return JSON.stringify(arr);
                } else {
                    var arr = [];
                    for(var i=0; i<this.objects_actual.length; i++){
                        arr[i] = this.objects_actual[i].id;
                    }
                    return arr;
                }
            },
            /**
             * returns the name of the modal
             * 
             * @return String the modal name
             */
            modal_name: function(){
                return 'add_' + this.name + '_modal';
            },
            /**
             * returns the name of the modal plus a hash
             * 
             * @return String the modal name
             */
            modal_name_hashed: function(){
                return '#add_' + this.name + '_modal';
            },
            /**
             * returns an a list of the selected items
             * 
             * @return String a list of selected items
             */
            name_list: function(){
                var arr = [];
                for(var i=0; i<this.objects_actual.length; i++){
                    if(this.objects_actual[i].route !== undefined){
                        arr[i] = '<span style="font-size:1.125rem"><a class="badge badge-secondary mr-3 mb-2" href="' + this.objects_actual[i].route + '" target="_blank">' + this.objects_actual[i].name + '</a></span>';
                    } else {
                        arr[i] = '<span style="font-size:1.125rem" class="badge badge-secondary mr-3 mb-2">' + this.objects_actual[i].name + '</span>';
                    }
                }
                if(this.default_all && this.objects_actual.length == 0){
                    arr[0] = '<span style="font-size:1.125rem" class="badge badge-secondary mr-3 mb-2">All</span>';
                }
                return arr.join('');
            },
            /**
             * returns a style to hide based on the condition
             * 
             * @return String the style
             */
            hide_if: function(){
                if(this.list_if){
                    return "";
                } else {
                    return "display:none";
                }
            },
            school_ids: function(){
                return this.$listSchoolIds;
            }
        },
        methods: {
            /**
             * closes the modal and avoids closing other modals
             */
            close_modal: function ()
            {
                $(this.modal_name_hashed).modal('hide');
            },
            /**
             * adds the selected item to the list
             */
            add_item_to_list: function ()
            {
                var object_to_use = null;
                if(this.object_value == '-1'){
                    object_to_use = {id: -1, name: ''};
                    if(this.has_secondary_array){
                        object_to_use[this.secondary_variable] = 0;
                    }
                    if(this.has_tertiary_array){
                        object_to_use[this.tertiary_variable] = 0;
                    }
                    this.add_to_list(object_to_use);
                } else {
                    object_to_use = this.find_id_all(this.object_value);
                    if(object_to_use != null){
                        //convert the item to a string
                        var add_string = object_to_use.add_objects + '';
                        var idArray = add_string.split(',');
                        for(var i=0; i<idArray.length; i++){
                            var object_to_add = this.find_id_all(idArray[i]);
                            this.add_to_list(object_to_add);
                        }
                    }
                }
            },
            /**
             * adds the object to the list
             * 
             * @param Object object_to_add the id of the object
             */
            add_to_list: function (object_to_add)
            {
                if(object_to_add != null && (this.has_secondary_array || !this.has_id(object_to_add.id) || object_to_add.id == -1)){
                    object_to_add = {...object_to_add};
                    this.objects_actual = this.objects_actual.concat([object_to_add]);
                    if(this.is_school){
                        this.$listSchoolIds = this.objects_actual;
                    }
                    this.$emit('objectsUpdated', this.objects_actual, this.name);
                }
            },
            /**
             * returns true if the object is contained in the list
             * 
             * @param int id the id of the object
             * 
             * @return Boolean true if in list
             */
            has_id: function(id){
                for(var i=0; i<this.objects_actual.length; i++){
                    if(id == this.objects_actual[i].id){
                        return true;
                    }
                }
                return false;
            },
            /**
             * finds the object based on id from all objects
             * 
             * @param int id the id of the object
             * 
             * @return Object the object
             */
            find_id_all: function(id){
                for(var i=0; i<this.all_objects_actual.length; i++){
                    if(id == this.all_objects_actual[i].id){
                        return this.all_objects_actual[i];
                    }
                }
                return null;
            },
            /**
             * finds the object based on id
             * 
             * @param int id the id of the object
             * 
             * @return Object the object
             */
            find_id: function(id){
                for(var i=0; i<this.objects_actual.length; i++){
                    if(id == this.objects_actual[i].id){
                        return this.objects_actual[i];
                    }
                }
                return null;
            },
            /**
             * removes an object from the list
             * 
             * @param int id the id of the object
             */
            remove_from_list: function(id, secondary){
                for(var i=0; i<this.objects_actual.length; i++){
                    if(this.objects_actual[i].id == id){
                        if(!this.has_secondary_array || this.objects_actual[i][this.secondary_variable] == secondary){
                            this.objects_actual.splice(i, 1);
                            i = this.objects_actual.length;
                        }
                    }
                }
                if(this.is_school){
                    this.$listSchoolIds = this.objects_actual;
                }
                this.$emit('objectsUpdated', this.objects_actual, this.name);
            },
            /**
             * checks if the object has route data
             * 
             * @param int id the id of the object
             * 
             * @return Boolean true if it has route date
             */
            check_route: function(id){
                var obj = this.find_id(id);
                if(obj != null){
                    return obj.route !== undefined;
                } else {
                    return true;
                }
            },
            /**
             * checks if the object has description data
             * 
             * @param int id the id of the object
             * 
             * @return Boolean true if it has description data
             */
            check_description: function(id){
                var obj = this.find_id(id);
                if(obj != null){
                    return obj.description !== undefined;
                } else {
                    return true;
                }
            },
            /**
             * checks if the object has extra data
             * 
             * @param int id the id of the object
             * 
             * @return Boolean true if it has extra data
             */
            check_extra: function(id){
                var obj = this.find_id(id);
                if(obj != null){
                    return obj.extra !== undefined;
                } else {
                    return true;
                }
            }
        },
        watch: {
            objects: function() {
                this.objects_actual = this.objects;
            },
        }
    }
</script>